var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name === 'projectMappingsAssignmentsCreate')?_c('Create'):(_vm.$route.name === 'projectMappingsAssignmentsEditor')?_c('Editor'):_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }